import React from 'react';

import { CTA } from 'react-scale/components';

import styles from './Hero.module.css';

const Hero = () => (
  <section className="py-16 md:py-32">
    <header className="container text-white">
      <span className="text-overtitle text-gradient">Scale Presents</span>
      <h1 className="my-6 text-4xl text-white font-aeonik md:text-6xl d:my-8">
        A<span className={styles.letter}>I</span> Futures
      </h1>
      <p className={`${styles.text} text-lg md:text-2xl mb-16`}>
        Piecing together our future through stories from the frontlines of AI.
      </p>
      <CTA
        cta={{
          hubspotModal: {
            formId: 'cfa8ac7e-4222-4a49-ba1a-2d0728a8b002',
            label: 'Get Updates'
          }
        }}
      />
    </header>
  </section>
);

export default Hero;
